import { LuLoaderCircle } from "react-icons/lu";
import InfiniteScroll from "react-infinite-scroll-component";
import { BuildJobStatusSchema } from "../../../../darvin-shared/schema/zod/build";
import {
  BuildPlatform,
  useProjectBuildActions,
  useProjectBuildsAndroid,
  useProjectBuildsWeb,
} from "../../../core_stores/useProjectBuildsStore";
import ProjectPublishBuildItem from "./ProjectPublishBuildItem";

export default function ProjectPublishBuilds({
  selectedPlatform,
}: {
  selectedPlatform: BuildPlatform;
}) {
  const builds =
    selectedPlatform === BuildPlatform.WEB
      ? useProjectBuildsWeb()
      : useProjectBuildsAndroid();
  const hasMore = builds?.pagination?.hasMore ?? false;

  const { loadBuilds } = useProjectBuildActions();

  if (selectedPlatform === BuildPlatform.WEB) {
    const webBuilds = builds?.builds;
    const buildsToShow = [];
    if (webBuilds && webBuilds.length > 0) {
      buildsToShow.push(webBuilds[0]);
      if (buildsToShow[0].status !== BuildJobStatusSchema.Enum.complete) {
        const latestCompleteBuild = webBuilds.find(
          (el) => el.status === BuildJobStatusSchema.Enum.complete
        );
        if (latestCompleteBuild) {
          buildsToShow.push(latestCompleteBuild);
        }
      }
    }
    return (
      <div className="flex-1 flex flex-col gap-4 overflow-hidden">
        <span className="text-lg font-medium">App Builds</span>
        {buildsToShow.map((build, index) => (
          <ProjectPublishBuildItem
            key={build.buildId}
            buildId={build.buildId}
            type={build.buildType}
            selectedPlatform={selectedPlatform}
            lastPublished={build.lastUpdateTimestamp}
            status={build.status}
            isExpanded={index === 0}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col gap-4 overflow-hidden">
      <span className="text-lg font-medium">App Builds</span>
      <InfiniteScroll
        dataLength={builds?.builds?.length ?? 0}
        next={() => loadBuilds(selectedPlatform, true)}
        hasMore={hasMore}
        loader={
          <div className="flex justify-center h-[50px]">
            <LuLoaderCircle size={24} className="animate-spin" />
          </div>
        }
        className="pr-2 overflow-hidden"
        scrollableTarget="builds-container"
      >
        {builds?.builds?.map((build, index) => (
          <ProjectPublishBuildItem
            key={build.buildId}
            buildId={build.buildId}
            type={build.buildType}
            selectedPlatform={selectedPlatform}
            lastPublished={build.lastUpdateTimestamp}
            status={build.status}
            isExpanded={index === 0}
          />
        ))}
      </InfiniteScroll>
    </div>
  );
}
